import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import ImageSlider from './components/ImageSlider';
import About from './components/About';
import Contact from './components/Contact';
import LogoSlider from './components/LogoSlider';
import Footer from './components/Footer';
import Bookings from './components/Bookings';
import BookingSystem from './components/BookingSystem';
import BookingAdmin from './components/BookingAdmin';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2c3e50', // Navy blue from logo
      light: '#34495e',
      dark: '#1a252f',
    },
    secondary: {
      main: '#8bc34a', // Green from logo dots and text
      light: '#aed581',
      dark: '#689f38',
    },
    background: {
      default: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '3.5rem',
      lineHeight: 1.2,
    },
    h2: {
      fontWeight: 600,
      fontSize: '2.5rem',
      lineHeight: 1.3,
    },
    h3: {
      fontWeight: 600,
      fontSize: '2rem',
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '1.1rem',
      lineHeight: 1.6,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
          padding: '12px 24px',
        },
      },
    },
  },
});

const HomePage = () => (
  <>
    <Hero />
    <Services />
    <ImageSlider />
    <About />
    <Contact />
    <LogoSlider />
  </>
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/bookings" element={<Bookings />} />
            <Route path="/booking" element={<BookingSystem />} />
            <Route path="/booking/admin" element={<BookingAdmin />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
